<div class="not-found">
  <div class="hero"></div>
  <h1 class="code">404</h1>
  <h2 class="title">Page Not Found</h2>
  <p class="desc">Sorry, the page you are looking for doesn't exist or has been moved.</p>
  <div class="actions" style="display: none;">
    <a class="btn primary" href="/">Go Home</a>
    <a class="btn outline" href="/contact-us">Contact Us</a>
  </div>
</div>


